import React from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import Footer from './components/Footer'
import { IoIosArrowBack } from 'react-icons/io'
import { RiEditLine } from 'react-icons/ri'
import Header2 from './components/Header2'
import Header3 from './components/Header3'
import Header5 from './components/Header5'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { BiMenu } from 'react-icons/bi'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

class Profile extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      errorDisplay: 'none',
      customername: '',
      businessname: '',
      affiliate: '',
      phone: '',
      email: '',
      dtregistered: '',
      bankname: '',
      account: '',
      accountnumber: '',
      branchcode: '',
      accountType: '',
      updated_at: '',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=ACCOUNTTYPE`, {
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          accountType: response.data.account_type,
        })
      })
      .catch((error) => {
        console.log(error)
      })

    if (localStorage.getItem('customername')) {
      const customername = localStorage.getItem('customername')
      const customerid = localStorage.getItem('customerid')
      document.title = customername + ' | Profile'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          this.setState({
            customername: response.data.customername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            facebook: '',
            twitter: '',
            instagram: '',
            linkedin: '',
            tiktok: '',
            address: '',
            updated_at: response.data.updated_at,
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    } else if (localStorage.getItem('businessname')) {
      const businessname = localStorage.getItem('businessname')
      const businessid = localStorage.getItem('businessid')
      document.title = 'Profile - ' + businessname + ' - Businessname'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=BUSINESSDETAILS&accountid=${businessid}`,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          this.setState({
            businessname: response.data.businessname ?? 'N/A',
            phone: response.data.phone ?? 'N/A',
            email: response.data.email ?? 'N/A',
            dtregistered: response.data.dtregistered ?? 'N/A',
            facebook: response.data.facebook ?? 'N/A',
            bankname: response.data.bankname ?? 'N/A',
            branchcode: response.data.branchcode ?? 'N/A',
            account: response.data.account ?? 'N/A',
            accountnumber: response.data.accountnumber ?? 'N/A',

            twitter: response.data.twitter ?? 'N/A',
            instagram: response.data.instagram ?? 'N/A',
            linkedin: response.data.linkedin || '',
            tiktok: response.data.tiktok || '',
            address: response.data.address ?? 'N/A',
            updated_at: response.data.updated_at ?? 'N/A',
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    } else {
      const partnername = localStorage.getItem('partnername')
      const partnerid = localStorage.getItem('partnerid')
      document.title = 'Karamale | Profile'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=${partnerid}`,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          this.setState({
            affiliate: response.data.partnername || '',
            phone: response.data.phone || '',
            email: response.data.email || '',
            dtregistered: response.data.dtregistered || '',
            bankname: response.data.bankname || '',
            branchcode: response.data.branchcode ?? '',
            account: response.data.account || '',
            accountnumber: response.data.accountnumber || '',
            updated_at: response.data.updated_at || '',

            facebook: response.data.facebook || '',
            twitter: response.data.twitter || '',
            instagram: response.data.instagram || '',
            linkedin: response.data.linkedin || '',
            tiktok: response.data.tiktok || '',
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  render() {
    let { accountname, dashboard } = ''
    if (localStorage.getItem('customername') === null) {
      if (localStorage.getItem('businessname') === null) {
        if (localStorage.getItem('partnername') === null) {
          return <Redirect to="/login" />
        } else {
          accountname = this.state.affiliate
          dashboard = 'in'
        }
      } else {
        accountname = this.state.businessname
        dashboard = 'dashboard'
      }
    } else {
      accountname = this.state.customername
    }
    const customername = accountname
    const twitter = this.state.twitter

    const str = String(this.state.accountnumber || '00000000000')
    const last4 = str.slice(-4)
    const masked = '*'.repeat(str.length - 4) + last4

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state
    return (
      <div className="view">
        <Header />
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}
        <div
          className="container"
          style={{
            marginTop: 40,
            marginLeft: this.state.isMobile ? '0px' : this.state.collapsed ? 'auto' : 'auto',
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div className="mobile-overlay active" onClick={this.handleToggle} />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <div className="row justify-content-center just-container-insid">
            <div className="col-lg-7 pl-0 pr-0">
              <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-4 col-6 pl-0">
                      <button onClick={() => this.props.history.goBack()} className="link-btn">
                        <IoIosArrowBack size={25} />
                        Back &nbsp;
                      </button>
                    </div>

                    <div className="col-lg-8 col-6 text-right p-0">
                      <label className="back-arrow mb-0">
                        <Link
                          to={{
                            pathname: 'editprofile',
                            state: {
                              accountname: customername,
                              email: this.state.email,
                              phone: this.state.phone,
                              dtregistered: this.state.dtregistered,
                              facebook: this.state.facebook,
                              twitter: this.state.twitter,
                              instagram: this.state.instagram,
                              address: this.state.address,
                            },
                          }}
                          className="link-btn"
                        >
                          <div className="edit-btn">Edit</div>
                        </Link>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {(this.state.accountType === 'business' || this.state.accountType === 'customer') && (
                <div className="row">
                  <div className={'col-lg-12 text-right'}>
                    <label className="ticket-title w-100 text-right">
                      <Link to="/b-details" className="color-blue font-normal">
                        Bank Details
                      </Link>
                    </label>
                  </div>
                </div>
              )}
              <div className=" BoxDashboardContainer pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0 pr-0">
                      <label className="ticket-title pl-0 pr-0 w-100">
                        MY ACCOUNTS
                        <label className="float-right">
                          <Link
                            to={{
                              pathname: '/changepassword',
                              state: {
                                credentials: 'password',
                              },
                            }}
                            className="color-blue font-normal"
                          >
                            Change Password
                          </Link>
                        </label>
                      </label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className="col-lg-12 details-body">
                  {this.state.accountType === 'partner'
                    ? 'Affiliate name'
                    : this.state.accountType === 'customer'
                    ? 'Name and surname'
                    : this.state.accountType === 'business'
                    ? 'Business name'
                    : 'Name and surname'}
                  <br />
                  <label className="small-details">{customername}</label>
                  <br /> <br />
                  Email address
                  <br />
                  <label className="small-details">{this.state.email}</label>
                  <br /> <br />
                  Phone number
                  <br />
                  <label className="small-details">{this.state.phone}</label>
                  <br />
                  <br />
                  Account created
                  <br />
                  <label className="small-details">{this.state.dtregistered}</label>
                  <br />
                  <br />
                  Updated on
                  <br />
                  <label className="small-details">{this.state.updated_at}</label>
                </div>
              </div>

              <div
                className={
                  this.state.accountType !== 'partner'
                    ? 'd-none'
                    : 'BoxDashboardContainer mt-4 mb-0 pl-0 pr-0'
                }
              >
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0 pr-0">
                      <label className="ticket-title pl-0 pr-0 w-100">
                        BANK DETAILS
                        <label className="float-right">
                          <Link to="/b-details">
                            <label className="mb-0 color-blue font-normal">Add/Edit</label>
                          </Link>
                        </label>
                      </label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className="col-lg-12 details-body">
                  Bank name
                  <br />
                  <label className="small-details">{this.state.bankname}</label>
                  <br /> <br />
                  Branch code
                  <br />
                  <label className="small-details">{this.state.branchcode}</label>
                  <br /> <br />
                  Account type
                  <br />
                  <label className="small-details">{this.state.account}</label>
                  <br />
                  <br />
                  Account number
                  <br />
                  <label className="small-details">{masked}</label>
                </div>
              </div>
              <div
                className={`${
                  this.state.accountType === 'customer'
                    ? 'd-none'
                    : 'BoxDashboardContainer mt-4 mb-5 pl-0 pr-0'
                }`}
              >
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0">
                      <label className="ticket-title pl-0 pr-0">SOCIAL MEDIA</label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className="col-lg-12 details-body">
                  Facebook
                  <br />
                  <label className="small-details">
                    <Link
                      to={{ pathname: this.state.facebook || '#' }}
                      target="_blank"
                      className={this.state.facebook === '' ? 'text-grey' : 'color-blue'}
                    >
                      {this.state.facebook}
                    </Link>
                    {this.state.facebook === '' ? 'Link not added' : ''}
                  </label>
                  <br /> <br />
                  X/Twitter
                  <br />
                  <label className="small-details">
                    <Link
                      to={{
                        pathname: this.state.twitter,
                      }}
                      target="_blank"
                      className={this.state.twitter === '' ? 'text-grey' : 'color-blue'}
                    >
                      {this.state.twitter}
                    </Link>
                    {this.state.twitter === '' ? 'Link not added' : ''}
                  </label>
                  <br /> <br />
                  Instagram
                  <br />
                  <label className="small-details">
                    <Link
                      to={{
                        pathname: this.state.instagram,
                      }}
                      target="_blank"
                      className={this.state.instagram === '' ? 'text-grey' : 'color-blue'}
                    >
                      {this.state.instagram}
                    </Link>
                    {this.state.instagram === '' ? 'Link not added' : ''}
                  </label>
                  <br />
                  <br />
                  Linkedin
                  <br />
                  <label className="small-details">
                    <Link
                      to={{
                        pathname: this.state.linkedin,
                      }}
                      target="_blank"
                      className={this.state.linkedin === '' ? 'text-grey' : 'color-blue'}
                    >
                      {this.state.linkedin}
                    </Link>
                    {this.state.linkedin === '' ? 'Link not added' : ''}
                  </label>
                  <br />
                  <br />
                  Tiktok
                  <br />
                  <label className="small-details">
                    <Link
                      to={{
                        pathname: this.state.tiktok || '#',
                      }}
                      target="_blank"
                      className={this.state.tiktok === '' ? 'text-grey' : 'color-blue'}
                    >
                      {this.state.tiktok}
                    </Link>
                    {this.state.tiktok === '' ? 'Link not added' : ''}
                  </label>
                  {this.state.accountType === 'business' ? (
                    <>
                      <br />
                      <br />
                      Business address
                      <br />
                      <label className="small-details pre-line">
                        {this.state.address == '' ? 'Address not added' : this.state.address}
                      </label>
                    </>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="error-login"
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
        {/* <Footer /> */}
      </div>
    )
  }
}

export default Profile
